import { Container, Col, Row } from "react-bootstrap";

// Pure video hero — no overlay text, CTAs, or RERA copy. The brand/H1/CTA
// block lives in <HeroContentSection /> right below so it stays crawlable
// and screen-reader-friendly without covering the video.
function HeroSectionStyleFive() {
  return (
    <>

    <div className="ltn__slider-area ltn__slider-4 position-relative ltn__primary-bg fix">
        <div className="ltn__slide-animation-active">

            {/* <!-- HTML5 VIDEO --> */}
            <video
              autoPlay
              muted
              loop
              playsInline
              preload="none"
              poster="/img/slider/41.webp"
              id="myVideo"
              aria-label="Hilltop Heights residential project — premium apartments and RL plots in Nagpur by Siddhivinayak Group"
            >
              <source src="/media/hilltop-banner-optimized-540p.mp4" type="video/mp4" />
              <track kind="captions" src="/media/captions-empty.vtt" srclang="en" label="No captions available" default />
            </video>

            <div
              className="ltn__slide-item ltn__slide-item-2 ltn__slide-item-7"
              role="img"
              aria-label="Aerial view of Hilltop Heights residential development, Ram Nagar, Nagpur"
              style={{
                backgroundImage: `url("/img/slider/41.webp")`,
              }}
            >
                <div className="ltn__slide-item-inner text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 align-self-center">
                                <div className="slide-item-info">
                                    <div className="slide-item-info-inner ltn__slide-animation"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    </>
  );
}

export default HeroSectionStyleFive;
